// Widget Scripts
import sliderShowMainFeature from './js/widgets/sliderShowMainFeature';
import seoWdiget from './js/widgets/seo';
import cardsList from './js/widgets/cardsList';
import multiScheduleFeature from './js/widgets/multiScheduleFeature';
import sponsorsList from './js/widgets/sponsorsList';
import topHeaderLinks from './js/widgets/topHeaderLinks';
import videoWidget from './js/widgets/videoWidget';

// Custom Theme Scripts
import './js/localjs';
import './js/widgets/countDown';

// Initialize Homepage Widgets
if (window.location.pathname === '/') {
  $(document).ready(() => {
    seoWdiget();
    cardsList();
    multiScheduleFeature();
  });

  $(window).on('load', () => {
    videoWidget();

    setTimeout(() => {
      if (!$('#youtubePlayer').length) {
        $('#videoSection').remove();
        sliderShowMainFeature();
      }
    }, 1000);

    setTimeout(() => {
      $('.countdown-section').css('opacity', '1');
    }, 500);
  });
} else {
  $(window).on('load', () => {
    $('.countdown-section').remove();
  });
}

$(document).ready(() => {
  sponsorsList();
  topHeaderLinks();
});

$(window).on('load', () => {});
